import PropTypes from 'prop-types';
import React from 'react';

import { toFixed } from 'utilities/number';
import { rateToggler } from 'utilities/playSpeed';

import ControlBarButton from '../control-bar-button';

import './styles.less';

const propTypes = { onRateChange: PropTypes.func };

export default function PlaybackRateControl(props) {
  return (
    <ControlBarButton
      className="video-player-playback-rate-control"
      hoverTagText="Speed (s)"
      seeking={props.seeking}
      onClick={rateToggler.bind(this, props.playbackRate)}
    >
      <span className="current-rate control-bar-button-icon">{`${
        props.playbackRate % 1 != 0
          ? toFixed(props.playbackRate, 1)
          : props.playbackRate
      }\u00D7`}</span>
    </ControlBarButton>
  );
}

PlaybackRateControl.propTypes = propTypes;
